import { motion } from "framer-motion";
import { Check } from "lucide-react";

const ITEMS = [
    { k: "01", v: "Palm cards & door hangers" },
    { k: "02", v: "Direct mail pieces" },
    { k: "03", v: "Yard signs & roadside signs" },
    { k: "04", v: "Social media graphics" },
    { k: "05", v: "Endorsement cards" },
    { k: "06", v: "Branding & logo packages" },
];

export default function CampaignMaterials() {
    return (
        <section
            id="materials"
            data-testid="materials-section"
            className="relative py-28 md:py-36 scratched-black grain overflow-hidden"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    {/* Headline */}
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="h-px w-8 bg-gold" />
                            <span className="text-[10px] uppercase tracking-[0.4em] text-gold font-semibold">
                                03 / Campaign Materials
                            </span>
                        </div>
                        <h2 className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight">
                            Materials that{" "}
                            <span className="italic text-gold">stand out</span> in
                            the mailbox.
                        </h2>
                        <p className="mt-8 text-cream/65 text-base md:text-lg leading-relaxed max-w-md">
                            A campaign's literature is often the first impression a
                            voter has of a candidate. We work with a talented graphic
                            design team that produces professional, eye-catching
                            materials built to make your campaign feel serious from
                            day one.
                        </p>
                        <div className="mt-10 inline-flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-gold/80 border border-gold/30 px-4 py-3">
                            <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" />
                            Consistent identity · From day one
                        </div>
                    </div>

                    {/* Items list — large editorial typography */}
                    <div className="lg:col-span-7">
                        <ul
                            data-testid="materials-list"
                            className="border-t border-gold/20"
                        >
                            {ITEMS.map((it, i) => (
                                <motion.li
                                    key={it.k}
                                    initial={{ opacity: 0, x: -10 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: i * 0.06 }}
                                    className="group flex items-baseline gap-6 md:gap-10 py-6 md:py-7 border-b border-gold/15 hover:bg-[#0a0a0a] transition-colors"
                                >
                                    <span className="font-mono text-[11px] text-gold/70 tracking-widest">
                                        {it.k}
                                    </span>
                                    <span className="flex-1 font-display text-2xl md:text-4xl text-cream group-hover:text-gold transition-colors leading-tight">
                                        {it.v}
                                    </span>
                                    <span className="opacity-0 group-hover:opacity-100 transition-opacity text-gold">
                                        <Check size={18} strokeWidth={2} />
                                    </span>
                                </motion.li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
